import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LandingPageComponent } from './features/users/components/landing-page/landing-page.component';
import { FunnelComponent } from './features/users/components/funnel/funnel.component';
import { VehicleDataComponent } from './features/users/components/funnel/vehicle-data/vehicle-data.component';
import { PickupComponent } from './features/users/components/funnel/pickup/pickup.component';
import { CatalogComponent } from './features/users/components/funnel/catalog/catalog.component';
import { RefuelingComponent } from './features/users/components/funnel/catalog/extra-steps/refueling/refueling.component';
import { WashComponent } from './features/users/components/funnel/catalog/extra-steps/wash/wash.component';
import { CatalogHomeComponent } from './features/users/components/funnel/catalog/extra-steps/catalog-home/catalog-home.component';
import { DefaultComponent } from './features/users/components/funnel/catalog/extra-steps/default/default.component';
import { SummaryComponent } from './features/users/components/funnel/summary/summary.component';
import { ExtrasComponent } from './features/users/components/funnel/extras/extras.component';
import { OverviewComponent } from './features/users/components/funnel/overview/overview.component';
import { PaymentComponent } from './features/users/components/payment/payment.component';
import { OwnershipChangeComponent } from './features/users/components/funnel/catalog/extra-steps/ownership-change/ownership-change.component';
import { ParkingComponent } from './features/users/components/funnel/catalog/extra-steps/parking/parking.component';
import { SuccessfulPaymentComponent } from './features/users/components/successful-payment/successful-payment.component';
import { ErrorPaymentComponent } from './features/users/components/error-payment/error-payment.component';

const routes: Routes = [
  {
    path: '',
    component: LandingPageComponent,
  },
  {
    path: 'landing',
    component: LandingPageComponent,
  },
  {
    path: 'payment',
    component: PaymentComponent,
  },
  {
    path: 'successful-payment',
    component: SuccessfulPaymentComponent,
  },
  {
    path: 'error-payment',
    component: ErrorPaymentComponent,
  },
  {
    path: 'funnel',
    component: FunnelComponent,
    children: [
      {
        path: 'vehicle-data',
        component: VehicleDataComponent,
      },
      {
        path: 'pickup',
        component: PickupComponent,
      },
      {
        path: 'catalog',
        component: CatalogComponent,
        children: [
          {
            path: 'refueling',
            component: RefuelingComponent,
          },
          {
            path: 'wash',
            component: WashComponent,
          },
          {
            path: 'default',
            component: DefaultComponent,
          },
          {
            path: 'ownership-change',
            component: OwnershipChangeComponent,
          },
          {
            path: 'parking',
            component: ParkingComponent,
          },
          {
            path: '',
            component: CatalogHomeComponent,
          },
        ],
      },
      {
        path: 'summary',
        component: SummaryComponent,
      },
      {
        path: 'extras',
        component: ExtrasComponent,
      },
      {
        path: 'overview',
        component: OverviewComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
